export default "__VITE_ASSET__CxLFBENn__"